<h3>
  <ng-content class="subtitle"></ng-content>
</h3>
